import type { AppEntryContext } from '@core/entities/AppEntryContext';
import type { AppEntryContextGateway } from '@core/ports/AppEntryContextGateway';

export class GetAppEntryContextUseCase {
  public constructor(private readonly appEntryContextGateway: AppEntryContextGateway) {}

  public execute(): Promise<AppEntryContext> {
    return this.appEntryContextGateway.getContext();
  }
}